export default {
    APPCODE: 'PORTAL-API',
    APP_SERVICE_CODE:100,
    APPSERVICECODE_LOGIN: 'login',
    APPSERVICECODE_BIND: 'bind',
    APPSERVICECODE_REG: 'register',
    APPSERVICECODE_PWD: 'ForgotPwd',
    APPCODE_PHONE: 'PORTAL-API',
    APPSERVICECODE_PHONE: '102',
    NC_PORTAL: 'https://ncopen.haiziwang.com',
    NC_PLATFORM: 'https://bid.haiziwang.com/bid/page/auth/main.do',
    NC_ENTER: 'https://zhaoshang.haiziwang.com/purchase-entering'
}
const isLeYou = /leyou/.test(window.location.hostname)

export {
    isLeYou
}